"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Select = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Filter = require("./partials/Filter");
var _DropList = require("./partials/DropList");
var _Footer = require("./partials/Footer");
var _Select = require("./Select.styles");
var _Select2 = require("./Select.labels");
var _hooks = require("../../hooks");
var _OffsetBox = require("../../Layout/OffsetBox");
var _useOffsetBox = require("../../Layout/OffsetBox/useOffsetBox");
var _Button = require("../Button");
var _Icon = require("../Icon");
var _strings = require("../../utilities/strings");
var _OffsetBoxDropCard = require("../partials/OffsetBoxDropCard");
var _Header = require("./partials/Header");
var _Card = require("../Card");
var _Portal = require("../../Layout/Portal");
var _CetComponentsProvider = require("../../providers/CetComponentsProvider");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const emptyArray = [];
const Select = exports.Select = /*#__PURE__*/_react.default.forwardRef((props, outerRef) => {
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const getLabel = (0, _hooks.useLabels)({
    labels: _Select2.labels
  });
  const {
    id,
    btnProps,
    anchorWidth = 'fit-content',
    isMultiSelect = false,
    isFullScreen = false,
    btnLabel = '',
    options = [],
    additionalOptions,
    optionSize = 'small',
    position = 'bottom',
    isAttachedToWindow = isMobileView,
    isWithFilter,
    isWithArrow = true,
    filterPlaceholder = '',
    additionalOptionsBtnLabel,
    isOpenOnFocus,
    isBoxCenteredToAnchor = false,
    isFocusFilterOnOpen = false,
    isSelectOnBlur = false,
    onClose,
    onBlur
  } = props;
  const {
    onChange: onChangeValue,
    value,
    isFixedBtnLabel
  } = props;
  const {
    values = emptyArray,
    onSecondaryBtnClick,
    onChange: onChangeValues,
    secondaryBtnLabel = getLabel('clear'),
    showSelection = false,
    maxSelectedOptions
  } = props;
  const [actualBoxPosition, setActualBoxPosition] = (0, _react.useState)(position);
  const [selectedOptions, setSelectedOptions] = (0, _react.useState)(values);
  const [optionsFilterText, setOptionsFilterText] = (0, _react.useState)('');
  const [FilteredOptions, setFilteredOptions] = (0, _react.useState)(options);
  const [FilteredAdditionalOptions, setFilteredAdditionalOptions] = (0, _react.useState)(additionalOptions);
  const closeRef = (0, _react.useRef)();
  const handleCancelAndClose = (0, _react.useCallback)(() => {
    if (!isSelectOnBlur) {
      setSelectedOptions(values);
    }
    if (onClose) {
      onClose();
    }
  }, [values, onClose, isSelectOnBlur]);
  const handleListBlur = (0, _react.useCallback)(event => {
    if (onBlur) {
      onBlur(event, selectedOptions);
    }
    if (isSelectOnBlur && onChangeValues) {
      onChangeValues(selectedOptions);
      closeRef?.current && closeRef.current();
    }
  }, [onBlur, selectedOptions, isSelectOnBlur, onChangeValues]);
  const {
    anchorRef,
    dropContentRef,
    handleAnchorFocus,
    handleAnchorKeyUp,
    isOpen,
    toggle,
    close
  } = (0, _useOffsetBox.useOffsetBox)(isOpenOnFocus, handleCancelAndClose, handleListBlur, isSelectOnBlur);
  closeRef.current = close;
  const styles = (0, _Select.useStyles)(props, isOpen);
  const arrowSize = btnProps?.size === 'large' ? 22 : btnProps?.size === 'small' ? 14 : 18;
  const getSelectBtnLabel = () => {
    if (isMultiSelect) {
      let label = btnLabel;
      const selectedCount = selectedOptions?.length;
      if (showSelection && selectedCount > 0) {
        const rest = selectedCount > 1 ? `(${selectedCount - 1}+)` : '';
        label += ` ${selectedOptions[0].label} ${rest}`;
      } else {
        label += selectedCount > 0 ? ' (' + selectedCount + ')' : '';
      }
      return label;
    } else if (value) {
      return btnLabel && isFixedBtnLabel ? btnLabel : value.label;
    } else {
      return btnLabel;
    }
  };
  const handleBoxPositionChange = pos => {
    setActualBoxPosition(pos);
  };
  const handleSelectOption = (0, _react.useCallback)(option => {
    if (onChangeValue) {
      onChangeValue(option);
      anchorRef.current && anchorRef.current.focus();
    }
    close();
  }, [onChangeValue, close, anchorRef]);
  const handleUpdateSelectedOptions = (0, _react.useCallback)(option => {
    if (isMultiSelect && selectedOptions.length > 0) {
      if (selectedOptions && selectedOptions.find(op => op.value === option.value)) {
        // remove option
        setSelectedOptions(selectedOptions.filter(op => op.value !== option.value));
      } else {
        // add option
        const newSelectedOptions = [...selectedOptions, option];
        const sortedSelectedOptions = options.filter(op => newSelectedOptions.map(item => item.value).includes(op.value)); // sort selected options by original options order
        const sortedSelectedAdditionalOptions = additionalOptions ? additionalOptions.filter(op => newSelectedOptions.map(item => item.value).includes(op.value)) : []; // sort selected additional options by original options order
        setSelectedOptions(sortedSelectedOptions.concat(sortedSelectedAdditionalOptions));
      }
    } else {
      setSelectedOptions([option]);
    }
  }, [isMultiSelect, selectedOptions, options, additionalOptions]);
  const handleClose = (0, _react.useCallback)(() => {
    handleCancelAndClose();
    close();
  }, [close, handleCancelAndClose]);
  const handleSecondaryBtnClick = (0, _react.useCallback)(() => {
    if (onSecondaryBtnClick) {
      onSecondaryBtnClick();
      anchorRef.current && anchorRef.current.focus();
    }
    close();
  }, [close, onSecondaryBtnClick, anchorRef]);
  const handleSaveSelectedOptions = (0, _react.useCallback)(() => {
    if (onChangeValues) {
      onChangeValues(selectedOptions);
      anchorRef.current && anchorRef.current.focus();
    }
    close();
  }, [close, onChangeValues, selectedOptions, anchorRef]);
  const filterOptionsBy = (0, _react.useCallback)(function (options, prop, value) {
    let isWithFullPrecision = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    return options?.filter(option => {
      return option.isSeparator || (isWithFullPrecision ? option[prop].toString() === value?.toString() : /*#__PURE__*/_react.default.isValidElement(option[prop]) ? (0, _strings.clearHtmlTags)(option[prop].props.children).includes(value?.toString()) : option[prop].toString().includes(value?.toString()));
    }) || [];
  }, []);
  const updateFilteredOptions = (0, _react.useCallback)((options, value) => {
    if (value) {
      setFilteredOptions(filterOptionsBy(options, 'label', value));
    } else {
      setFilteredOptions(options);
    }
  }, [filterOptionsBy]);
  const updateFilteredAdditionalOptions = (0, _react.useCallback)((additionalOptions, value) => {
    if (value) {
      setFilteredAdditionalOptions(filterOptionsBy(additionalOptions, 'label', value));
    } else {
      setFilteredAdditionalOptions(additionalOptions);
    }
  }, [filterOptionsBy]);
  const handleAnimationComplete = () => {
    if (!isMultiSelect && selectedOptions?.length === 1 && dropContentRef?.current) {
      const scrollContainer = dropContentRef.current ?? document;
      const selectedItem = scrollContainer.querySelector('[data-value="' + selectedOptions[0].value + '"]');
      if (selectedItem) {
        selectedItem.scrollIntoView({
          block: 'center'
        });
      }
    }
  };
  const handleUpdateOptionsFilterText = value => {
    setOptionsFilterText(value);
  };
  (0, _react.useEffect)(() => {
    updateFilteredOptions(options, optionsFilterText);
    if (additionalOptions) {
      updateFilteredAdditionalOptions(additionalOptions, optionsFilterText);
    }
  }, [options, additionalOptions, optionsFilterText, updateFilteredOptions, updateFilteredAdditionalOptions]);
  (0, _react.useEffect)(() => {
    if (outerRef) {
      outerRef.current = anchorRef.current; //todo: fix type
    }
  }, [anchorRef, outerRef]);
  (0, _react.useEffect)(() => {
    if (isMultiSelect && values) {
      setSelectedOptions(values);
    }
  }, [values, isMultiSelect]);
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [isAttachedToWindow && isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Portal.Portal, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: styles['cc-Select-mask']
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: styles['cc-Select'],
      "data-testid": id ? `select-${id}` : null,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_OffsetBox.OffsetBox, {
        isAttachedToWindow: isAttachedToWindow,
        position: position,
        isOpen: isOpen,
        isCenteredToAnchor: isBoxCenteredToAnchor,
        onBoxPositionChange: handleBoxPositionChange,
        anchorWidth: anchorWidth,
        anchor: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Button.Button, {
          ref: anchorRef,
          ...btnProps,
          onClick: toggle,
          onFocus: handleAnchorFocus,
          onKeyUp: handleAnchorKeyUp,
          role: "button",
          ariaHaspopup: "listbox",
          ariaExpanded: isOpen,
          children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: styles['cc-Select__btn'],
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: styles['cc-Select__btn__label'],
              children: getSelectBtnLabel()
            }), isWithArrow && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: styles['cc-Select__btn__arrow'],
              children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
                name: "Caret",
                width: arrowSize,
                height: arrowSize,
                fillColor: btnProps?.color === 'basic' && (btnProps?.view === 'outlined' || btnProps?.view === 'text') ? themeColors?.primary.main : 'currentColor'
              })
            })]
          })
        }),
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_OffsetBoxDropCard.OffsetBoxDropCard, {
          id: id ? `select-${id}` : undefined,
          ref: dropContentRef,
          position: actualBoxPosition,
          onAnimationComplete: handleAnimationComplete,
          isWithFilter: isWithFilter,
          isAttachedToWindow: isAttachedToWindow,
          isFullScreen: isFullScreen,
          width: btnProps?.customStyle?.width,
          onClose: handleClose,
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(_Card.Card.Section, {
            size: "small",
            flexValues: {
              flexGrow: 1
            },
            children: [isMobileView && isMultiSelect && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.Header, {
              label: getSelectBtnLabel(),
              isOptionsSelected: Boolean(selectedOptions.length),
              secondaryBtnLabel: secondaryBtnLabel,
              onSecondaryBtnClick: handleSecondaryBtnClick
            }), isWithFilter && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Filter.Filter, {
              value: optionsFilterText,
              onUpdateValue: handleUpdateOptionsFilterText,
              placeholder: filterPlaceholder,
              isFullScreen: isFullScreen,
              isFocused: isFocusFilterOnOpen
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_DropList.DropList, {
              options: isMultiSelect ? FilteredOptions.map(option => ({
                ...option,
                isDisabled: maxSelectedOptions ? selectedOptions.length >= maxSelectedOptions && !selectedOptions.find(op => op.value === option.value) : false
              })) : FilteredOptions,
              additionalOptions: FilteredAdditionalOptions,
              selectedOptions: isMultiSelect ? selectedOptions : value ? [value] : [],
              onSelectOption: isMultiSelect ? handleUpdateSelectedOptions : handleSelectOption,
              isMultiSelect: isMultiSelect,
              isFullScreen: isFullScreen,
              isWithFilter: isWithFilter,
              optionSize: optionSize,
              additionalOptionsBtnLabel: additionalOptionsBtnLabel?.length ? additionalOptionsBtnLabel : getLabel('showAdditionalOptions'),
              id: btnProps?.label ? `${btnProps?.label}-select` : undefined
            })]
          }), isMultiSelect && !isSelectOnBlur && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Footer.Footer, {
            onSaveSelectedOptions: handleSaveSelectedOptions,
            onClearSelectedOptions: handleSecondaryBtnClick,
            isOptionsSelected: Boolean(selectedOptions.length)
          })]
        })
      })
    })]
  });
});